export enum SliceType {
  Clients = 'clients',
  MoreSettings = 'moreSettings',
  Webhooks = 'webhooks',
  XRay = 'xRay',
  XRayDebug = 'xRayDebug',
  XRayLibrary = 'xRayLibrary',
}
